"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../../../constants/icons");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var alert_1 = require("../../../constants/molecules/alert");
var SvgSpriteLoader_1 = __importDefault(require("../SvgSpriteLoader"));
var ALERT_STYLE = (_a = {},
    _a[alert_1.AlertTypes.SUCCESS] = 'tw-text-GREEN_PRIMARY tw-bg-GREEN_TERTIARY tw-bg-BLUE_6 tw-border-GREEN_PRIMARY',
    _a[alert_1.AlertTypes.PENDING] = 'tw-border-ZAMP_PRIMARY tw-text-ZAMP_PRIMARY tw-bg-BLUE_6',
    _a[alert_1.AlertTypes.ERROR] = 'tw-border-ORANGE_SECONDARY tw-text-RED_PRIMARY tw-bg-ORANGE_TERTIARY',
    _a);
var Alert = function (_a) {
    var alertType = _a.alertType, children = _a.children, _b = _a.overrideClassName, overrideClassName = _b === void 0 ? 'tw-flex tw-justify-between tw-items-center tw-py-3 tw-px-4 tw-rounded-lg' : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.iconOverrideClassName, iconOverrideClassName = _d === void 0 ? 'tw-cursor-pointer' : _d, _e = _a.iconClassName, iconClassName = _e === void 0 ? '' : _e, onClose = _a.onClose, id = _a.id, eventCallback = _a.eventCallback;
    var handleClose = function () {
        eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.ALERT_CLOSE_CLICK, { id: id });
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return (react_1.default.createElement("div", { className: overrideClassName + " " + className + " " + ALERT_STYLE[alertType], "data-testid": "alert-wrapper-" + id },
        children,
        onClose && (react_1.default.createElement(SvgSpriteLoader_1.default, { id: 'x-close', iconCategory: icons_1.ICON_SPRITE_TYPES.GENERAL, className: iconClassName + " " + iconOverrideClassName, width: 20, height: 20, onClick: handleClose }))));
};
exports.Alert = Alert;
